import { Button } from '../../components';
import type { PresetType } from './usePresets';

type PresetsProps = {
  presets: PresetType[];
  onClick: (text: string) => void;
};

const isPreset = (data: unknown): data is PresetType => {
  return (
    typeof data === 'object' &&
    !!data &&
    'label' in data &&
    'text' in data &&
    typeof data['label'] === 'string' &&
    typeof data['text'] === 'string'
  );
};

const Presets: React.FC<PresetsProps> = ({ presets: data, onClick }) => {
  return (
    !!data?.length && (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-md mt-md">
        {data.filter(isPreset).map((item, index) => {
          return (
            <Button key={index} onClick={() => onClick(item.text)}>
              <div className="truncate" title={item.label}>
                {item.label}
              </div>
            </Button>
          );
        })}
      </div>
    )
  );
};

export default Presets;
